"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubFormType = void 0;
exports.isFormFieldNestedList = isFormFieldNestedList;
exports.isFormFieldSelectList = isFormFieldSelectList;
exports.isFormFieldSubForm = isFormFieldSubForm;
var SubFormType;
(function (SubFormType) {
    SubFormType["NONE"] = "None";
    SubFormType["POLE"] = "pole";
    SubFormType["SPAN"] = "span";
})(SubFormType || (exports.SubFormType = SubFormType = {}));
function isFormFieldNestedList(field) {
    return field.type === 'nestedlist';
}
function isFormFieldSelectList(field) {
    return field.type === 'selectlist';
}
function isFormFieldSubForm(field) {
    return field.type === 'form';
}
//# sourceMappingURL=form.js.map